// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var CryptoJs = require("crypto-js");
var Aes = require("crypto-js/aes");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");

var Encoder = {};

function Make($$Crypto) {
  var encryptString = function (message, key) {
    return Curry._2($$Crypto.encryptToBuffer, message, key).toString();
  };
  var decryptString = function (encryptedMessage, key, maybeEncoder, param) {
    var encoder = OptionUtils$SmartcutsMacros.withDefault(CryptoJs.enc.Utf8, maybeEncoder);
    return Curry._2($$Crypto.decryptToBuffer, encryptedMessage, key).toString(encoder);
  };
  return {
          encryptString: encryptString,
          decryptString: decryptString
        };
}

function Crypto_encryptToBuffer(prim0, prim1) {
  return Aes.encrypt(prim0, prim1);
}

function Crypto_decryptToBuffer(prim0, prim1) {
  return Aes.decrypt(prim0, prim1);
}

function encryptString(message, key) {
  return Curry._2(Crypto_encryptToBuffer, message, key).toString();
}

function decryptString(encryptedMessage, key, maybeEncoder, param) {
  var encoder = OptionUtils$SmartcutsMacros.withDefault(CryptoJs.enc.Utf8, maybeEncoder);
  return Curry._2(Crypto_decryptToBuffer, encryptedMessage, key).toString(encoder);
}

var AES = {
  encryptString: encryptString,
  decryptString: decryptString
};

exports.Encoder = Encoder;
exports.Make = Make;
exports.AES = AES;
/* crypto-js Not a pure module */
